import { Button, Space } from 'antd';
import { FC } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import PaymentTemplates from './PaymentTemplates';

export interface IFooterProps {
  onClose: () => void;
  param?: ObjectInterface | null;
  orderId?: string;
  bnameList?: string;
  regType?: string;
}

const Footer: FC<IFooterProps> = ({ onClose, param, bnameList, orderId }) => {
  return (
    <Space>
      <BrowserView>
        <PaymentTemplates bnameList={bnameList} orderId={orderId} param={param} regType="web" />
      </BrowserView>
      <MobileView>
        <PaymentTemplates bnameList={bnameList} param={param} orderId={orderId} regType="mobile" />
      </MobileView>
      <Button onClick={onClose}>취소</Button>
    </Space>
  );
};

export default Footer;
